'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _index = require('rmc-picker/lib/index.web');

var _index2 = _interopRequireDefault(_index);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _DatePickerMixin = require('./DatePickerMixin');

var _DatePickerMixin2 = _interopRequireDefault(_DatePickerMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DatePickerWeb = React.createClass({
    displayName: 'DatePickerWeb',

    mixins: [_DatePickerMixin2["default"]],
    getDefaultProps: function getDefaultProps() {
        return {
            prefixCls: 'rmc-date-picker',
            pickerPrefixCls: 'rmc-picker',
            disabled: false
        };
    },
    render: function render() {
        var _this = this;

        var props = this.props;
        var prefixCls = props.prefixCls;
        var pickerPrefixCls = props.pickerPrefixCls;
        var className = props.className;
        var rootNativeProps = props.rootNativeProps;
        var disabled = props.disabled;

        var _getValueDataSource = this.getValueDataSource();

        var value = _getValueDataSource.value;
        var dataSource = _getValueDataSource.dataSource;

        var inner = dataSource.map(function (items, i) {
            return React.createElement(
                'div',
                { key: i, className: prefixCls + '-item' },
                React.createElement(
                    _index2["default"],
                    { disabled: disabled, prefixCls: pickerPrefixCls, pure: false, selectedValue: value[i], onValueChange: function onValueChange(v) {
                            _this.onValueChange(i, v);
                        } },
                    items
                )
            );
        });
        return React.createElement(
            'div',
            (0, _extends3["default"])({}, rootNativeProps, { className: (0, _classnames2["default"])(className, prefixCls) }),
            inner
        );
    }
});
exports["default"] = DatePickerWeb;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rmc-date-picker/lib/DatePicker.web.js
 ** module id = 418
 ** module chunks = 0
 **/